export default __webpack_public_path__ + "static/media/trash-2.bfbd5924.svg";